import React from "react";
import CTAButton from "../Buttons/CTAButton/CTAButton";
import ContentImageMobile from "../../assets/images/Image Container.png";
import CelebratingLegacy from "../../assets/shapes/Celebrating a Legacy.svg";

const ContentSectionMobile = () => {
  return (
    <div>
      <section className="bg-Color-White">
        <ImageContainer />
        <ContentText/>
      </section>
    </div>
  );
};

export default ContentSectionMobile;

export const ImageContainer = () => {
  return (
    <div className="relative">
      <div className=" w-full overflow-hidden">
        <img
          src={ContentImageMobile}
          alt="ContentImageMobile"
          className="w-full h-full object-cover object-center"
        />
      </div>
    </div>
  );
};
export const ContentText = () => {
  return (
    <div className="relative pt-numbers-32">
      <div className="self-stretch px-4 inline-flex flex-col justify-start items-start gap-8">
        <div className="self-stretch justify-start text-Color-Black text-xs font-normal font-['Montserrat'] tracking-tight">
          The Faculty of Engineering, University of Ruhuna, proudly marks its
          25th Anniversary this year! For a quarter of a century, we have been
          at the forefront of engineering education and research in Sri Lanka,
          nurturing generations of brilliant minds who have gone on to shape
          industries, drive innovation, and contribute significantly to national
          and global development.
        </div>
        <CTAButton text="READ MORE" url="https://www.eng.ruh.ac.lk/" target="_blank"/>
      </div>
    </div>
  );
};
